export interface VideoCropRect {
  sx: number;
  sy: number;
  sw: number;
  sh: number;
}

export function calculateVideoCrop(
  video: HTMLVideoElement,
  overlay: HTMLElement,
  objectFit: 'cover' | 'contain' = 'cover',
): VideoCropRect | null {
  const videoWidth = video.videoWidth;
  const videoHeight = video.videoHeight;
  if (!videoWidth || !videoHeight) {
    return null;
  }

  const videoRect = video.getBoundingClientRect();
  const frameRect = overlay.getBoundingClientRect();
  if (videoRect.width <= 0 || videoRect.height <= 0 || frameRect.width <= 0 || frameRect.height <= 0) {
    return null;
  }

  const elementRatio = videoRect.width / videoRect.height;
  const videoRatio = videoWidth / videoHeight;

  let renderedWidth: number;
  let renderedHeight: number;
  let offsetX: number;
  let offsetY: number;

  if (objectFit === 'cover') {
    if (videoRatio > elementRatio) {
      renderedHeight = videoRect.height;
      renderedWidth = videoRect.height * videoRatio;
      offsetX = (videoRect.width - renderedWidth) / 2;
      offsetY = 0;
    } else {
      renderedWidth = videoRect.width;
      renderedHeight = videoRect.width / videoRatio;
      offsetX = 0;
      offsetY = (videoRect.height - renderedHeight) / 2;
    }
  } else if (videoRatio > elementRatio) {
    renderedWidth = videoRect.width;
    renderedHeight = videoRect.width / videoRatio;
    offsetX = 0;
    offsetY = (videoRect.height - renderedHeight) / 2;
  } else {
    renderedHeight = videoRect.height;
    renderedWidth = videoRect.height * videoRatio;
    offsetX = (videoRect.width - renderedWidth) / 2;
    offsetY = 0;
  }

  const scaleX = videoWidth / renderedWidth;
  const scaleY = videoHeight / renderedHeight;

  const relativeX = frameRect.left - videoRect.left;
  const relativeY = frameRect.top - videoRect.top;

  let sx = (relativeX - offsetX) * scaleX;
  let sy = (relativeY - offsetY) * scaleY;
  let sw = frameRect.width * scaleX;
  let sh = frameRect.height * scaleY;

  if (sx < 0) {
    sw += sx;
    sx = 0;
  }
  if (sy < 0) {
    sh += sy;
    sy = 0;
  }
  if (sx + sw > videoWidth) {
    sw = videoWidth - sx;
  }
  if (sy + sh > videoHeight) {
    sh = videoHeight - sy;
  }

  if (sw <= 1 || sh <= 1) {
    return null;
  }

  return {
    sx: Math.round(sx),
    sy: Math.round(sy),
    sw: Math.round(sw),
    sh: Math.round(sh),
  };
}
